import React from 'react'
import { FlexRow, FlexColumn, Text, Icon, Tooltip, Select } from 'elements'
import SeverityCircle from '../../../common/SeverityCircle'

const formatSeverityOptionLabel = (props) => {
  const { label, value } = props

  return (
    <FlexRow alignItems="center">
      <SeverityCircle severity={value} styleProps={{ boxProps: { mr: 'medium' } }} />
      <Text>{label}</Text>
    </FlexRow>
  )
}

const severityOptions = [
  { label: 'High', value: 2 },
  { label: 'Medium', value: 1 },
  { label: 'Low', value: 0 },
]

export default function SeverityThreshold({ configSection, value, onChange }) {
  return (
    <FlexRow alignItems="center" mb="large" justifyContent="space-between">
      <FlexRow alignItems="center" flex="1">
        <Text fontWeight="bold" mr="xsmall">
          Severity
        </Text>
        <Icon
          name="question-circle"
          data-tip
          data-for={`${configSection.name}-severity`}
          color="neutral.1"
          size="xsmall"
        />
      </FlexRow>
      <Tooltip id={`${configSection.name}-severity`}>
        <FlexColumn>
          <Text>Select the severity level of this anomaly.</Text>
        </FlexColumn>
      </Tooltip>
      <FlexColumn flex="1">
        <Select
          options={severityOptions}
          formatOptionLabel={formatSeverityOptionLabel}
          value={severityOptions.find((option) => option.value === value)}
          placeholder="Select Severity"
          onChange={(option) => onChange(option.value)}
        />
      </FlexColumn>
    </FlexRow>
  )
}
